export const ActionsheetContent = {
  baseStyle: () => ({
    _dragIndicator: {
      bg: '#D9D9D9'
    }
  })
}
